import React from "react";
import {observer} from "mobx-react";
import { ICheckboxesTreeItem } from "../../../../../../../../../../components/inputs/checkboxes-tree-dropdown/checkboxes-tree/stores/checkboxes-tree-store";
import Label, {LABEL_VARIANT} from "../../../../../../../../../../components/label/label";
import {ICompareValueTypeComponentProps} from "../../condition-field";
import LocationCompareValueStoreList from "../../../../../../../../stores/compare-value/location-compare-value-list-stores/location-compare-value-store-list";
import LocationLabels from "./location-labels";
import CheckboxesTreeDropdown from "../../../../../../../../../../components/inputs/checkboxes-tree-dropdown/checkboxes-tree-dropdown";

/**
 * Renders the location list compare value editor using CheckboxesTreeDropdown.
 * Narrowed view of the compare value store required by this component.
 */
const LocationCompareValueList: React.FC<ICompareValueTypeComponentProps> = observer(({store, condition, operatorSelector}) => {
    const locationStore = store as LocationCompareValueStoreList;
    const optionsTree: ICheckboxesTreeItem[] = locationStore.getOptionsTree();
    const valueTree: ICheckboxesTreeItem[] | undefined = locationStore.getValueTree();
    const labels = locationStore.getGroupedLabels();

    const tagsCloudStyles = {
        display: "flex",
        flexBasis: "100%",
        gap: 8,
        flexWrap: "wrap" as const,
        whiteSpace: "break-spaces" as const
    }

    return (
        <>
            {operatorSelector}
            <div style={{minWidth: "400px"}}>
                <CheckboxesTreeDropdown
                    options={optionsTree}
                    value={valueTree}
                    onChange={locationStore.onLocationsChanged}
                    compressed={true}
                    isCheckboxesListDisabled={!condition.isEditMode}
                    isSearchInputDisabled={!condition.isEditMode}
                    searchInputPlaceholder={'Select locations'}
                />
            </div>
            {labels.isSelectAll && (
                <div style={tagsCloudStyles}>
                    <Label labelText="All locations" variant={LABEL_VARIANT.ACCENT} />
                </div>
            )}
            {!labels.isSelectAll && labels.groups.length > 0 && (
                <div style={tagsCloudStyles}>
                    {labels.groups
                        .filter((group) => group?.parentLabel)
                        .map((group) => (
                            <LocationLabels
                                key={group.parentLabel}
                                labelsGroup={group}
                            />
                        ))
                    }
                </div>
            )}
        </>
    );
});

export default LocationCompareValueList;